import React, { createContext, useState, useContext } from 'react';

const SuggestedDataContext = createContext();

export const SuggestedDataProvider = ({ children }) => {
  // Sugerencias que vienen del backend
  const [suggestedData, setSuggestedData] = useState({
    address: [],
    card: [],
    referral: [],
    contact: [],
    employment: [],
    bank: null,
  });

  // Selección del usuario (id o array de ids)
  const [selectedData, setSelectedData] = useState({
    address: null,
    card: null,
    referral: [],
    contact: null,
    employment: null,
    bank: null,
  });

  return (
    <SuggestedDataContext.Provider value={{
      suggestedData,
      setSuggestedData,
      selectedData,
      setSelectedData
    }}>
      {children}
    </SuggestedDataContext.Provider>
  );
};

export const useSuggestedData = () => useContext(SuggestedDataContext);